/**
 * 연락처 오버레이 컨트롤러.
 *
 * [data-fw-contact-open="groom"] 클릭 → [data-fw-contact-overlay="groom"] 열림.
 * side 키(groom/bride 등) 로 짝을 매칭. overlay 내부의 [data-fw-contact-close] 또는
 * overlay 배경 클릭 시 닫힘.
 */
export const CONTACT_OVERLAY_CONTROLLER_SCRIPT = `
<script data-fw-contact-overlay-controller>
(function () {
  function close(overlay) {
    overlay.classList.remove('active');
    overlay.style.display = 'none';
    if (overlay.dataset.fwLocked === '1') {
      overlay.dataset.fwLocked = '0';
      if (window.__fwScrollLock) window.__fwScrollLock.unlock();
      else document.body.style.overflow = '';
    }
  }
  function open(overlay) {
    overlay.classList.add('active');
    if (getComputedStyle(overlay).display === 'none') overlay.style.display = 'flex';
    if (overlay.dataset.fwLocked === '1') return; // 이미 열려 있으면 중복 락 방지
    overlay.dataset.fwLocked = '1';
    if (window.__fwScrollLock) window.__fwScrollLock.lock({ allowScrollWithin: overlay });
    else document.body.style.overflow = 'hidden';
  }
  function init() {
    var opens = document.querySelectorAll('[data-fw-contact-open]');
    for (var i = 0; i < opens.length; i++) {
      var btn = opens[i];
      if (btn.dataset.fwContactOpenInit) continue;
      btn.dataset.fwContactOpenInit = '1';
      var side = btn.getAttribute('data-fw-contact-open') || '';
      var overlay = document.querySelector('[data-fw-contact-overlay="' + side.replace(/"/g, '') + '"]');
      if (!overlay) continue;
      btn.addEventListener('click', (function (ov) {
        return function (e) { e.preventDefault(); open(ov); };
      })(overlay));
      if (!overlay.dataset.fwContactOverlayInit) {
        overlay.dataset.fwContactOverlayInit = '1';
        overlay.addEventListener('click', (function (ov) {
          return function (e) { if (e.target === ov) close(ov); };
        })(overlay));
        var closeBtn = overlay.querySelector('[data-fw-contact-close]');
        if (closeBtn) closeBtn.addEventListener('click', (function (ov) {
          return function () { close(ov); };
        })(overlay));
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=contact-overlay.js.map